const DATA_SAVED = "extragestor/ventasTareas/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/ventasTareas/RESET_DATA_SAVED";

const ADDED_TAREA_DE_VENTA = "extragestor/ventasTareas/ADDED_TAREA_DE_VENTA";
const REMOVED_TAREA_DE_VENTA =
  "extragestor/ventasTareas/REMOVED_TAREA_DE_VENTA";
const CHANGED_TAREA_DE_VENTA =
  "extragestor/ventasTareas/CHANGED_TAREA_DE_VENTA";

const LIMPIAR_TAREAS_DE_VENTA =
  "extragestor/ventasTareas/LIMPIAR_TAREAS_DE_VENTA";

/*---------------------------------------------------------------------------*/

export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  ADDED_TAREA_DE_VENTA,
  REMOVED_TAREA_DE_VENTA,
  CHANGED_TAREA_DE_VENTA,
  LIMPIAR_TAREAS_DE_VENTA
};



// WEBPACK FOOTER //
// ./src/ducks/ventasTareas/types.js